module.exports = __webpack_public_path__ + "ptc_momoro_S2.775c42a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_S2.jpg
// module id = qlKT
// module chunks = 0